// 全局错误处理插件
export default defineNuxtPlugin((nuxtApp) => {
  // 获取 toast 服务
  const toast = nuxtApp.$toast;
  
  // 错误消息映射
  const errorMessages: Record<string, Record<string, string>> = {
    'zh': {
      'badRequest': '请求参数错误',
      'unauthorized': '未授权，请重新登录',
      'forbidden': '没有权限执行此操作',
      'notFound': '请求的资源不存在',
      'serverError': '服务器内部错误',
      'networkError': '网络连接失败，请检查您的网络',
      'unknownError': '请求失败，请稍后重试'
    },
    'en': {
      'badRequest': 'Invalid request parameters',
      'unauthorized': 'Unauthorized, please log in again',
      'forbidden': 'You don\'t have permission to perform this action',
      'notFound': 'The requested resource does not exist',
      'serverError': 'Internal server error',
      'networkError': 'Network connection failed, please check your network',
      'unknownError': 'Request failed, please try again later'
    }
  };
  
  // 获取当前语言
  const getCurrentLocale = () => {
    try {
      return localStorage.getItem('locale') || 'zh';
    } catch (e) {
      return 'zh';
    }
  };
  
  // 获取错误消息
  const getErrorMessage = (key: string) => {
    const locale = getCurrentLocale();
    const messages = errorMessages[locale] || errorMessages['zh'];
    return messages[key] || messages['unknownError'];
  };
  
  // 监听全局 API 错误事件
  if (process.client) {
    window.addEventListener('api-error', ((event: CustomEvent) => {
      const { message, status, url } = event.detail;
      console.log(`API错误 (${status}): ${message}`, url);
      
      // 根据状态码选择合适的错误消息
      let errorKey = 'unknownError';
      
      if (message) {
        // 如果有错误消息，直接显示
        (toast as any)?.error(message);
      } else {
        // 否则根据状态码显示通用错误消息
        switch (status) {
          case 400:
            errorKey = 'badRequest';
            break;
          case 401:
            errorKey = 'unauthorized';
            break;
          case 403:
            errorKey = 'forbidden';
            break;
          case 404:
            errorKey = 'notFound';
            break;
          case 500:
            errorKey = 'serverError';
            break;
          case 0:
            errorKey = 'networkError';
            break;
        }
        
        const errorMessage = getErrorMessage(errorKey);
        (toast as any)?.error(errorMessage);
      }
    }) as EventListener);
  }
}); 